import { create } from 'zustand';

/**
 * What the machine is doing.
 *
 *   null       nothing — the desktop is live
 *   'logoff'   the Log Off Windows panel is up, waiting for an answer
 *   'shutdown' the Turn off computer panel is up, waiting for an answer
 *   'restart'  Restart was chosen; the screen is on its way to black
 *   'off'      Turn Off was chosen; the screen is on its way to black
 */
export type ShutdownPhase = null | 'logoff' | 'shutdown' | 'restart' | 'off';

interface ShutdownStore {
  phase: ShutdownPhase;
  /** Raise the panel, or commit to an ending. */
  begin(phase: Exclude<ShutdownPhase, null>): void;
  /** Back out — Cancel and Escape both land here. */
  cancel(): void;
}

/**
 * The power state, kept outside the window manager because it outranks it:
 * the Start menu writes to it and `ShutdownOverlay` is the only reader.
 *
 * Deliberately not persisted. A machine that came back from a reload still
 * turned off would have no way to switch itself on again.
 */
export const useShutdownStore = create<ShutdownStore>((set) => ({
  phase: null,
  begin: (phase) => set({ phase }),
  cancel: () => set({ phase: null }),
}));
